import { type ReactElement } from "react";

type Props = Readonly<{
  videoSrc: string;
  videoTitle?: string;
}>;

export default function TiktokCard({
  videoSrc,
  videoTitle,
}: Props): ReactElement {
  const parameter = "?autoplay=0&music_info=1&description=1";
  const videoId = videoSrc.split("/v1/")[1];

  return (
    <div id={`tiktok-card-${videoId}`} data-testid="tiktok-card">
      <iframe
        src={`${videoSrc}${parameter}` || ""}
        allow="fullscreen"
        className="aspect-[9/16] size-full min-w-[276px] lg:min-w-full"
        title={videoTitle ? videoTitle : "Tiktok Video"}
      />
    </div>
  );
}
